export default "stage";